/**
 * Removes characters from filenames that are not alphanumeric, dots, underscores, or hyphens.
 * Prevents consecutive, leading, and trailing delimiters.
 */
export const removeInvalidFilenameCharacters = (str: string, replacement = '-'): string => {
  // Escape the replacement char for use in Regex if it's a special character
  const escapedRep = replacement.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  return (
    str
      // 1. Replace all illegal chars with the replacement
      .replace(/[^0-9a-zA-Z._-]/g, replacement)
      // 2. Collapse multiple replacements into one: "---" -> "-"
      .replace(new RegExp(`${escapedRep}{2,}`, 'g'), replacement)
      // 3. Remove leading replacement: "-foo" -> "foo"
      .replace(new RegExp(`^${escapedRep}+`), '')
      // 4. Remove replacement before a dot: "foo-.mp4" -> "foo.mp4"
      .replace(new RegExp(`${escapedRep}+(?=\\.)`, 'g'), '')
      // 5. Remove trailing replacement: "foo-" -> "foo"
      .replace(new RegExp(`${escapedRep}+$`), '')
  );
};
